import React, { useState, useEffect, Fragment } from 'react';

import { Card, CardBody, CardTitle, Button, Badge } from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { NavLink } from 'react-router-dom';
import moment from 'moment';
import {
  gAPI_Conversations_list,
  gAPI_userName,
} from '../../../../../constants/APIs';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
// Helper to fetch agent name by agentID

import parse from 'html-react-parser';
import ChatListItem from '../../../../../components/chats/ChatListItem';
import 'react-datepicker/dist/react-datepicker.css';
import Masking from '../../../../../data/Masking';
import messenger_icon from '../../../../../assets/messenger_icon.png';
import teams from '../../../../../assets/teams.png';
import website_icon from '../../../../../assets/website_icon.png';
import google_icon from '../../../../../assets/google_icon.png';
import insta_icon from '../../../../../assets/insta_logo.png';
import {
  faLock,
  faLockOpen,
  faUserTie,
} from '@fortawesome/free-solid-svg-icons';
import WechatLogo from '../../../../../assets/wechat_icon.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import noallConversation from '../../../../../assets/no_allconvo.png';
import { connect } from 'react-redux';
import { fetchServiceRequest } from '../../../../../redux/service/actions';
const Archives = ({
  startDate,
  endDate,
  offset,
  items,
  isLoading,
  data,
  activeIndex,
  handleContactClick,
  pid,
  loadMoreConversations,
  handleMaskClick,
  isMasked,
  properties,
  serviceProvider,
  featuresUrl,
  emailLogs,
  openLatestEmailLogs,
  fetchServiceRequest,
}) => {
  const [conversations, setConversations] = useState(
    Array.isArray(data) ? data : []
  );
  //   const [offsetNum, setOffsetNum] = useState(offset || null);
  const [itemsNum, setItemsNum] = useState(items || null);
  const [loading, setLoading] = useState(false);

  const fetchAgentName = async (agentID) => {
    try {
      const res = await AxiosAPI({
        method: 'get',
        url: `${gAPI_userName}/${agentID}`,
      });
      return res?.data?.fullName || '';
    } catch (e) {
      return '';
    }
  };
  const [agentNames, setAgentNames] = useState({});

  // Fetch agent names for all agents in conversations
  useEffect(() => {
    const fetchAllAgentNames = async () => {
      let agentIdSet = new Set();
      conversations.forEach((chat) => {
        if (chat.agents && Array.isArray(chat.agents)) {
          chat.agents.forEach((agentId) => agentIdSet.add(agentId));
        }
      });
      const ids = Array.from(agentIdSet).filter(Boolean);
      const nameMap = {};
      await Promise.all(
        ids.map(async (id) => {
          nameMap[id] = await fetchAgentName(id);
        })
      );
      setAgentNames(nameMap);
    };
    fetchAllAgentNames();
  }, [conversations]);

  useEffect(() => {
    if (serviceProvider) {
      fetchServiceRequest(serviceProvider);
    }
  }, [serviceProvider]);
  useEffect(() => {
    setConversations(Array.isArray(data) ? data : []);
  }, [data]);

  // --- Add inside Archives.js component (React functional component scope) ---
  useEffect(() => {
    const handleSetActive = (e) => {
      try {
        const twilioId = e?.detail?.twilioId;
        if (twilioId) {
          // setActiveChat is in scope in this component
          setActiveChat(twilioId);
        }
      } catch (err) {
        console.warn('Error handling myma_set_active_chat event', err);
      }
    };

    window.addEventListener('myma_set_active_chat', handleSetActive);
    return () => {
      window.removeEventListener('myma_set_active_chat', handleSetActive);
    };
  }, [conversations]); // include conversations so setActiveChat finds the latest list

  const getImage = (phoneNumber, source, conversation) => {
    const assets_Url =
      featuresUrl && !featuresUrl.includes('myma.ai')
        ? `https://assets.${featuresUrl}`
        : 'https://assets.bookmebob.com';
    if (source === 'Phone') {
      if (phoneNumber !== '' && phoneNumber !== undefined) {
        if (
          phoneNumber.startsWith('+6422') ||
          phoneNumber.startsWith('+6427') ||
          phoneNumber.startsWith('+6421') ||
          phoneNumber.startsWith('+6428') ||
          phoneNumber.startsWith('+6429')
        ) {
          return (
            <img
              src={`${assets_Url}/images/mobile.png`}
              alt="mobile"
              className="img-thumbnail border-0 mt-2 ml-2"
              style={{ maxWidth: '35px' }}
            />
          );
        } else {
          return (
            <img
              // src="https://assets.bookmebob.com/images/landline.png"
              src={`${assets_Url}/images/landline.png`}
              alt="landline"
              className="img-thumbnail border-0 mt-2 ml-2"
              style={{ maxWidth: '35px' }}
            />
          );
        }
      } else {
        return (
          <img
            // src="https://assets.bookmebob.com/images/chat.png"
            src={`${assets_Url}/images/chat.png`}
            alt="chat"
            className="img-thumbnail border-0 mt-2 ml-2"
            style={{ maxWidth: '35px' }}
          />
        );
      }
    } else if (source === 'PhoneSuite') {
      // return <i className="simple-icon-call-in" style={{ fontSize: '25px' }} />;

      if (conversation?.callDirection === 'outbound') {

        return <img
          src={"/assets/img/outbound-calling.png"}
          alt={'chat'}
          className="img-thumbnail border-0"
          style={{ maxWidth: '35px' }}
        />

      } else {

        return <img
          src={"/assets/img/inbound-calling.png"}
          alt={'chat'}
          className="img-thumbnail border-0"
          style={{ maxWidth: '35px' }}
        />
      }
    } else if (source === 'WebsiteDirectLine') {
      return <i className="simple-icon-globe" style={{ fontSize: '25px' }} />;
    } else if (source === 'EmailDirectLine') {
      return <i className="iconsminds-envelope" style={{ fontSize: '25px' }} />;
    } else if (source === 'GoogleBusinessMessage') {
      return (
        <img
          src={google_icon}
          alt="google"
          className="img-thumbnail border-0 mt-2"
          style={{ maxWidth: '25px' }}
        />
      );
    } else if (source === 'WhatsApp') {
      return (
        <img
          src="https://assets.bookmebob.com/images/whatsapp_icon.png"
          //src={`${assets_Url}/images/whatsapp_icon.png`}
          alt="whatsapp"
          className="img-thumbnail border-0 mt-2 "
          style={{ maxWidth: '28px' }}
        />
      );
    } else if (source === 'FacebookDirectLine') {
      return (
        <img
          src={messenger_icon}
          alt="facebook"
          className="img-thumbnail border-0 mt-2"
          style={{ maxWidth: '25px' }}
        />
      );
    } else if (source === 'TeamsApp') {
      return (
        <img
          src={teams}
          alt="Teans"
          className="img-thumbnail border-0 mt-2"
          style={{ maxWidth: '25px' }}
        />
      );
    } else if (source === 'WeChat') {
      return (
        <img
          src={WechatLogo}
          alt="Teans"
          className="img-thumbnail border-0 mt-2"
          style={{ maxWidth: '25px' }}
        />
      );
    } else if (source === 'InstagramDirectLine') {
      return (
        <img
          src={insta_icon}
          alt="Teans"
          className="img-thumbnail border-0 mt-2"
          style={{ maxWidth: '25px', marginBottom: '8px' }}
        />
      );
    } else {
      return (
        <img
          // src="https://assets.bookmebob.com/images/chat.png"
          src={`${assets_Url}/images/chat.png`}
          alt="chat"
          className="img-thumbnail border-0 mt-2"
          style={{ maxWidth: '25px' }}
        />
      );
    }
  };
  // const getImage = (phoneNumber, source) => {
  //   if (source === 'Phone') {
  //     if (phoneNumber !== '' && phoneNumber !== undefined) {
  //       if (
  //         phoneNumber.startsWith('+6422') ||
  //         phoneNumber.startsWith('+6427') ||
  //         phoneNumber.startsWith('+6421') ||
  //         phoneNumber.startsWith('+6428') ||
  //         phoneNumber.startsWith('+6429')
  //       ) {
  //         return 'https://assets.bookmebob.com/images/mobile.png';
  //       } else {
  //         return 'https://assets.bookmebob.com/images/landline.png';
  //       }
  //     } else {
  //       return 'https://assets.bookmebob.com/images/chat.png';
  //     }
  //   }
  //   else if (source === 'PhoneSuite') {
  //     return 'https://assets.bookmebob.com/images/664a7811-8899-4255-8fe8-a12a6bd8b500.png';
  //   }
  //   else if (source === 'WebsiteDirectLine') {
  //     return 'https://assets.bookmebob.com/images/2504d2db-ab38-4616-a7ea-d16a4e81bd6f.png';
  //   }
  //   else if (source === 'GoogleBusinessMessage') {
  //     return google_icon;
  //   }
  //   else if (source === 'WhatsApp') {
  //     return 'https://assets.bookmebob.com/images/whatsapp_icon.png';
  //   }
  //   else if (source === 'FacebookDirectLine') {
  //     return messenger_icon;
  //   }
  //   else {
  //     return 'https://assets.bookmebob.com/images/chat.png';
  //   }
  // };

  // useEffect(() => {
  //   const start = moment(startDate).format('YYYY-MM-DD') + ' 00:00:00';
  //   const end = moment(endDate).format('YYYY-MM-DD') + ' 23:59:59';
  //   AxiosAPI({
  //     methhod: 'get',
  //     url: `${gAPI_Conversations_list}?gid=${getGroupID()}&pid=${pid}&df=${start}&dt=${end}&tags=-1&offset=${0}&limit=${itemsNum}&country=-1&facebookSenderName=`,
  //     //  url: `${gAPI_Conversations_list}?gid=${getGroupID()}&country=${
  //     //    code.length > 0 ? code.map(a => a.value).join('|') : '-1'
  //     //  }&tags=${
  //     //    topicName.length > 0
  //     //      ? topicName.map(a => a.value).join('|')
  //     //      : '-1'
  //     //  }&pid=${
  //     //    hotel.length > 0 ? hotel.map(a => a.value).join('|') : '-1'
  //     //  }&df=${start}&dt=${end}&offset=${offset}&limit=${items}`,
  //   }).then(res => {
  //     setConversations(res.data.conversations);
  //     setLoading(false);
  //   });
  // }, [itemsNum, endDate, startDate]);

  const loadMore = () => {
    // setOffsetNum(offsetNum + 30);
    // setItemsNum(itemsNum + 30);
    // setLoading(true);
    loadMoreConversations();
  };

  const setActiveChat = (twilioId) => {
    console.log('setActiveChat', twilioId);
    if (conversations && conversations.length > 0) {
      const chatIndex = conversations.findIndex(
        (c) => c.twilioChatId === twilioId
      );
      console.log('chatIndex', chatIndex);
      if (chatIndex !== -1) {
        handleContactClick(chatIndex, conversations[chatIndex].conversationId);
      }
    }
  };

  const [showButton, setShowButton] = useState(false);
  const handleScroll = (e) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop - 10 <= e.target.clientHeight;
    if (bottom && Array.isArray(conversations) && conversations.length > 0) {
      setShowButton(true);
    }
  };
  return (
    <Fragment>
      <div className="cardHeight archive-card mb-2" style={{ scrollbarColor: 'darkgrey white' }} onScroll={handleScroll}>
        {!isLoading ? (
          <>
            {Array.isArray(conversations) && conversations.length > 0 ? (
              <div className="mt-2">
                {conversations.map((chat, index) => {
                  return (
                    // <Fragment>
                    //   <NavLink
                    //     key={`chat_${index}`}
                    //     className={
                    //       activeIndex === index
                    //         ? 'd-flex selectedchat'
                    //         : 'd-flex'
                    //     }
                    //     to="#"
                    //     onClick={() =>
                    //       handleContactClick(index, chat.conversationId)
                    //     }
                    //   >
                    //     <ChatListItem key={`chat_${index}`} item={chat} />
                    //   </NavLink>
                    // </Fragment>
                    <div
                      key={`chat_${index}`}
                      className={
                        activeIndex === index
                          ? 'd-flex flex-row mb-2 border-bottom selectedchat'
                          : 'd-flex flex-row mb-2 border-bottom'
                      }
                      style={{ cursor: 'pointer', width: '100%' }}
                      onClick={() =>
                        handleContactClick(index, chat.conversationId)
                      }
                    >
                      <div className="d-block mx-2" style={{ alignContent: 'center' }}                        >
                        {/* {getImage(chat.phoneNumber, chat.channel)} */}

                          {chat?.interactionSource === "elevenlabs" ? <img
                            src={"/assets/img/preview-calling.png"}
                            alt={'chat'}
                            className="img-thumbnail border-0"
                            style={{ maxWidth: '35px' }}
                          /> : getImage(chat.phoneNumber, chat.channel, chat)}
                          {/* <img
                              src={getImage(chat.phoneNumber, chat.channel)}
                              alt={'chat'}
                              className="img-thumbnail border-0 mt-2 ml-2"
                              style={{ maxWidth: '35px' }}
                            /> */}
                      </div>
                      <div className="pl-3 pt-2 pr-2 pb-2" style={{ width: '100%' }}>
                        {/* Agent badge on the left */}
                        {chat.agents &&
                          Array.isArray(chat.agents) &&
                          chat.agents.length > 0 && (
                            <div
                              style={{
                                marginBottom: 4,
                                display: 'flex',
                                gap: 6,
                                flexWrap: 'wrap',
                              }}
                            >
                              {chat.agents.map((agentId) =>
                                agentNames[agentId] ? (
                                  <Badge
                                    key={agentId}
                                    color="info"
                                    className="d-flex align-items-center"
                                    style={{ marginRight: 0 }}
                                  >
                                    <FontAwesomeIcon
                                      icon={faUserTie}
                                      style={{ marginRight: 4 }}
                                    />
                                    {agentNames[agentId]}
                                  </Badge>
                                ) : null
                              )}
                            </div>
                          )}
                        {/* Property badge on the right */}
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            marginBottom: 4,
                          }}
                        >
                          {pid === '-1' &&
                            chat.propertyId !== undefined &&
                            properties !== undefined &&
                            properties !== null &&
                            properties.length > 0 &&
                            properties.filter(
                              (p) => p.id === chat.propertyId
                            ).length > 0 &&
                            (() => {
                              const propertyName = properties.filter(
                                (p) => p.id === chat.propertyId
                              )[0].name;
                              return (
                                <Badge
                                  color="primary"
                                  pill
                                  className="badge-conversation"
                                  style={{ marginRight: 0 }}
                                  title={propertyName}
                                >
                                  {propertyName}
                                </Badge>
                              );
                            })()}
                        </div>
                        <div className="text-primary text-small font-weight-medium d-none d-sm-block">
                          {moment(chat.startedUtc).format(
                            'MMM DD, YYYY h:mm a'
                          )}
                          &nbsp; ({chat.visitorMessageCount})
                        </div>
                        {chat.channel === 'EmailDirectLine' ? (
                          <p className="mb-1 text-small my-1"></p>
                        ) : (
                          <p className="mb-1 text-small">
                            {chat.detail}
                          </p>
                        )}
                        <p className="text-muted mb-1 text-small">
                          {isMasked !== 'true' ? (
                            <Masking
                              input={chat.phoneNumber}
                              inputType={'mobile'}
                              number={4}
                            ></Masking>
                          ) : (
                            chat.phoneNumber
                          )}
                          {chat.phoneNumber !== '' &&
                            chat.phoneNumber !== null && (
                              <span
                                className="text-muted ml-1"
                                style={{ cursor: 'pointer' }}
                                onClick={() => handleMaskClick()}
                              >
                                <FontAwesomeIcon
                                  icon={
                                    isMasked === 'true'
                                      ? faLock
                                      : faLockOpen
                                  }
                                  className="fa"
                                />
                              </span>
                            )}
                        </p>
                        <p className="text-muted mb-1 text-small">
                          {isMasked !== 'true' ? (
                            <Masking
                              input={chat.email}
                              inputType={'email'}
                            ></Masking>
                          ) : (
                            chat.email
                          )}
                          {chat.email !== '' && chat.email !== null && (
                            <span
                              className="ml-1"
                              style={{ cursor: 'pointer' }}
                              onClick={() => handleMaskClick()}
                            >
                              <FontAwesomeIcon
                                icon={
                                  isMasked === 'true'
                                    ? faLock
                                    : faLockOpen
                                }
                                className="fa"
                              />
                            </span>
                          )}
                        </p>
                      </div>
                    </div>
                  );
                })}
                {showButton && (
                  <Button
                    style={{ float: 'right', marginRight: '10px', marginBottom: '10px', paddingBottom: '5px'}}
                    color="primary"
                    size="xs"
                    onClick={loadMore}
                  >
                    More
                  </Button>
                )}
              </div>
            ) :
              <Fragment>
                {Array.isArray(emailLogs) && emailLogs.length > 0 ? (
                  <div className="mb-3">
                    {emailLogs.map((chat, index) => {
                      return (
                        <div
                          key={`chat_${index}`}
                          className={
                            activeIndex === index
                              ? 'd-flex flex-row mb-2 border-bottom selectedchat'
                              : 'd-flex flex-row mb-2 border-bottom'
                          }
                          style={{ cursor: 'pointer', width: '100%' }}
                          onClick={() =>
                            openLatestEmailLogs(chat, index)
                          }
                        >
                          <div
                            className="d-block mx-1"
                            style={{ alignContent: 'center' }}
                          >
                            {getImage(chat?.phoneNumber, 'EmailDirectLine',chat)}
                          </div>
                          <div
                            className="pl-3 pt-2 pr-2 pb-2"
                            style={{ width: '100%' }}
                          >
                            <div style={{ width: '100%' }}>
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'flex-end',
                                  marginBottom: 4,
                                }}
                              >
                                {pid === '-1' &&
                                  chat.propertyId !== undefined &&
                                  properties !== undefined &&
                                  properties !== null &&
                                  properties.length > 0 &&
                                  properties.filter(
                                    (p) => p.id === chat.propertyId
                                  ).length > 0 &&
                                  (() => {
                                    const propertyName = properties.filter(
                                      (p) => p.id === chat.propertyId
                                    )[0].name;
                                    return (
                                      <Badge
                                        color="primary"
                                        pill
                                        className="badge-conversation"
                                        style={{ marginRight: 0 }}
                                        title={propertyName}
                                      >
                                        {propertyName}
                                      </Badge>
                                    );
                                  })()}
                              </div>
                              <div className="text-primary text-small font-weight-medium d-none d-sm-block">
                                {moment(chat.date).format(
                                  'MMM DD, YYYY h:mm a'
                                )}
                              </div>
                              <p className="mb-1 text-small my-1">
                                {chat.action}
                              </p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    {showButton && (
                      <Button
                        style={{ float: 'right', margin: '10px' }}
                        color="primary"
                        size="xs"
                        onClick={loadMore}
                      >
                        More
                      </Button>
                    )}
                  </div>
                ) :
                  <div className="text-center no-ticket">
                    <img
                      src={noallConversation}
                      alt="No Tickets"
                      style={{
                        width: '80%',
                      }}
                    />
                  </div>
                }
              </Fragment>
            }
          </>
        ) : (
          <div className="loading" />
        )}

        {loading && (
          <div
            style={{ textAlign: 'center', fontSize: '16px', margin: '8px 0' }}
          >
            Loading ...
          </div>
        )}
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({ settings, service }) => {
  const { serviceProvider } = settings;
  const { featuresUrl } = service;
  return {
    serviceProvider,
    featuresUrl,
  };
};

export default connect(mapStateToProps, { fetchServiceRequest })(Archives);
